import { CUSTOM_EVENTS } from '../../../../../../client/constants/communication-custom-events';
import { appConfig as $config } from '../../app.config';
import { Common } from '../../modules/Common';
import { UI } from '../../modules/UI';
import { App } from '../../modules/App';
import { User } from '../../modules/User';
import { MasterProductData } from '../../modules/MasterProductData';
import { SortFilter } from '../../modules/SortFilter';
import { ProductInfo } from '../../modules/ProductInfo';
import { BlankInfo } from '../../modules/BlankInfo';
import { ArtworkInfo } from '../../modules/ArtworkInfo';
import { KSFModal, MockupStatus, orderProductionStatusErrorModal } from '../../modules/ReactComponent';

import { Columns } from './dt-columns';

import './scss/orders.scss';
import React from 'react';

export const Orders = (function () {
  const dataGridId = '#LineItemsDataTable';
  let selectedStore = 'All';
  let selectedProduct = '';
  let $dataGrid;
  let lastQuery;

  let $datesRangeDefaults = {
    start: moment(new Date(2019, 0, 1)),
    end: moment()
  };

  const statusesWhenControlActive = [0, 2];
  const printerColumnTitles = {
    'Kornit Avalanche': $Lang.orders.productionInfo.KSFDirectory,
    'Aeoon Kyo Link': $Lang.orders.productionInfo.ASFDirectory
  };

  let mapping = {
    datatable: (data) => {
      const selected = App.pageData('selectedOrdersRows') || [];
      return data.map((o) => {
        o.DT_RowId = o.id;
        o.serviceProviderCode =
          o.serviceProviders && o.serviceProviders.length > 0 && o.serviceProviders[0].code != 'Email'
            ? o.serviceProviders[0].code
            : '';
        o.selected = selected.find((item) => item.lineItemInStoreId == o.id);
        if (o.lookupServiceProviders) {
          o.selectedFacilities = o.lookupServiceProviders.find((p) => p.isSelected)?.facilities;
        } else {
          o.lookupServiceProviders = [];
        }
        o.controlActive = statusesWhenControlActive.includes(o.productionStatus);
        o.checkDisable = o.lookupServiceProviders.every((lookupServiceProvider) => !lookupServiceProvider.isSelected);
        // KSF / ASF Directory column title
        o.dtgPrintInfoPerPanel?.forEach((panel) => {
          if (panel.ksfDirectoryItems) {
            panel.ksfDirectoryItems.forEach((item) => {
              if (item.printer && item.printer.name) {
                item.printer.columnTitle = printerColumnTitles[item.printer.name]
                  ? printerColumnTitles[item.printer.name]
                  : $lang.orders.productionInfo.FilesDirectory;
              }
            });
          }
        });
        return o;
      });
    },
    datesRangeFormat: (data) => {
      return {
        start: moment(data.start).format($config.appFullDateFormat),
        end: moment(data.end).format($config.appFullDateFormat)
      };
    }
  };

  let init = (params = {}, query = '') => {
    lastQuery = { params: '', query: '', pagename: $lang.pagetitle.OrdersRouting, pageurl: '/orders' };

    if (params && params.action && params.id) {
      if (params.action === 'masterProductData') {
        let providerCode;
        if (query) {
          providerCode = KTUtil.getParameterByName('?providerCode', query);
        }
        return masterProductDataPage(params.id, params.subAccountId, providerCode);
      }
    }

    let uri = Common.segmentedURI();
    selectedStore = Common.getQueryVal('Store', uri.query) || selectedStore;
    selectedProduct = Common.getQueryVal('ProductId', uri.query) || selectedProduct;
    let pageData = {
      stores: ['All', 'Shopify', 'Archive'],
      datesRange: mapping.datesRangeFormat($datesRangeDefaults),
      selectedStore: selectedStore,
      selectedProduct: selectedProduct
    };

    let template = require('./tmpl/orders.hbs');
    UI.page(template, pageData).then(() => {
      // Import Sales Order Handler
      $('.js-action-ImportSalesOrder').off().on('click', () => {
        window.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.ORDER_IMPORT_ACTION, null));
      });
      $('.js-action-SubmitOrders').off().on('click', submitOrders);
      $('#cancelLiteItemsBtn').off().on('click', () => doCancelDelete('cancel-line-items'));
      $('#cancelOrdersBtn').off().on('click', () => doCancelDelete('cancel'));
      $('#deleteOrdersBtn').off().on('click', () => doCancelDelete('delete'));

      dataGridInit();
    });
  };

  let dataGridInit = () => {
    UI.block('#page');

    $dataGrid = $('#LineItemsDataTable').DataTable({
      destroy: true,
      columns: Columns.orders,
      ajax: ajaxData,
      serverSide: true,
      stateSave: true,
      responsive: {
        details: {
          type: 'column',
          target: -1
        }
      },
      cache: false,
      searching: false,
      ordering: false,
      drawCallback: drawCallback,
      processing: true,
      dom: '<"row"<"col text-right"p>><"row"<"col-sm-12"t>><"row"<"col text-right"p>>',
      initComplete: () => {
        UI.unblock('#page');
      }
    });
    $dataGrid.on('responsive-display', function (e, datatable, row, showHide, update) {
      let tableid = $(e.target).attr('id');
      if (!$(`#${tableid}`).length) return;
      detailsRow(row, showHide, true);
    });

    $dataGrid.on('change', '.kt-checkable', selectHandler);
  };

  let ajaxData = (data, callback) => {
    const sendData = {
      pageLimit: data.length,
      page: data.start / data.length + 1,
      requestPage: 'Orders',
      storeName: selectedStore === 'Archive' ? 'All' : selectedStore
    };

    const url = selectedStore === 'Archive' ? 'OrdersArchive/filter' : 'Orders/filter';

    const responseMapper = (responseData) => {
      const excludedSortItems = ['TotalSales'];

      if (!responseData?.responseObject) {
        return {
          ...responseData,
          filterData: {
            filterItems: [...(responseData?.filterData?.filterItems || [])],
            sortItems: [
              ...(responseData?.filterData?.sortItems || []).filter((s) => !excludedSortItems.includes(s.sortColumn))
            ]
          }
        };
      }

      return {
        ...responseData,
        ...responseData.responseObject,
        filterData: {
          filterItems: [...responseData.responseObject.filterData.filterItems],
          sortItems: [
            ...responseData.responseObject.filterData.sortItems.filter((s) => !excludedSortItems.includes(s.sortColumn))
          ]
        },
        requestPage: selectedStore === 'Archive' ? 'OrdersArchive' : 'Orders'
      };
    };

    $.when(App.ajaxData(url, sendData, 'POST', 'application/json', false, responseMapper)).done((res) => {
      if (!SortFilter.isInit('#ordersFilters')) {
        let template = require(`./tmpl/partial/quick-filters.hbs`);
        $('#ordersQuickFilters')
          .empty()
          .html(
            template({
              assetMasterAccounts:
                res?.filterData?.filterItems?.find((f) => f.internalName === 'Licensor')?.defaultValues || []
            })
          );

        SortFilter.init({
          selector: '#ordersFilters',
          pagename: selectedStore === 'Archive' ? 'OrdersArchive' : 'orders',
          requestPage: selectedStore === 'Archive' ? 'orders' : '',
          update: () => {
            App.ajaxAbortAll();
            $dataGrid.draw(false);
          }
        });
      }

      const gridData = mapping.datatable(res.data);

      App.pageData('serviceProviders', res.serviceProviders);
      App.pageData('ordersGridData', gridData);
      App.pageData('selectedStore', selectedStore);

      callback({
        recordsTotal: res.totalCount || 0,
        recordsFiltered: res.totalCount || 0,
        data: gridData
      });

      $(window).scrollTop(0);
    });
  };

  let drawCallback = () => {
    UI.unblock('#page');

    // Image popup
    $('.magnific-image').magnificPopup({ type: 'image' });

    // Select2 Dropdowns
    $('.order-type-select, .print-method-select').select2().on('change', dropdownHandler);
    $('.service-provider-select').select2().on('change', serviceProviderDropdownHandler);

    $('#page')
      .off()
      .on('click', '.details-control', handleToggleAdditionalBlock)
      .on('click', '.js-action-exporttoexel', exportToExel)
      .on('click', '.js-action-productinfo-dialog', productInfoDialog)
      .on('click', '.js-action-production-error-dialog', productStatusErrorDialog);

    // Data Binder
    dataBinder.dataBind(document.body, window);

    // Restore collapsed rows
    restoreCollapsed();
  };

  let dropdownHandler = (e) => {
    const target = $(e.target);
    const lineItemId = target.data('lineiteminstoreid');
    const value = target.val();
    const checkbox = $(`.kt-checkable[data-id="${lineItemId}"]`);
    const serviceProvider = target.hasClass('service-provider-select');
    const printMethod = target.hasClass('print-method-select');

    const selected = App.pageData('selectedOrdersRows') || [];

    updateSelectedData(lineItemId, true);

    if (!value) {
      checkbox.prop('checked', false);
    } else {
      if (selected.find((item) => item.lineItemInStoreId == lineItemId)) {
        updateSelectedData(lineItemId);
      }
    }

    // Disable row checkbox
    /*if (serviceProvider) {
      checkbox.prop('disabled', !value);
    }*/

    // Switch visible PrintMethod Tables
    if (printMethod && $dataGrid.row(`#${lineItemId}`).child.isShown()) {
      $(`[data-lineitemid="${lineItemId}"].printmethod-section`).addClass('d-none');
      $(`[data-printmethod="${value}"][data-lineitemid="${lineItemId}"].printmethod-section`).removeClass('d-none');
    }
  };

  let serviceProviderDropdownHandler = (e) => {
    const target = $(e.target);
    const lineItemId = target.data('lineiteminstoreid');
    const value = target.val();

    const selected = App.pageData('selectedOrdersRows') || [];

    const selectedOrder = selected.find(order => order.lineItemInStoreId === lineItemId);
    if (!selectedOrder) {
      return;
    }

    selectedOrder.serviceProviderId = value;
    selectedOrder.checkDisable = !value;

    App.pageData('selectedOrdersRows', selected);

    App.pageData(
      'submitOrdersEnabled',
      selectedStore !== 'Archive' && selected.some((order) => order.controlActive && !order.checkDisable)
    );
  };

  let handleToggleAdditionalBlock = (e) => {
    if ($(dataGridId).hasClass('collapsed')) {
      return false;
    }

    let id = $(e.target).closest('tr').attr('id');
    let row = $(dataGridId)
      .DataTable()
      .row('#' + id);

    if (row.child.isShown()) {
      row.child.hide();
      $('#' + id).removeClass('details');

      // Remove Saved selected row
      storeCollapsed(id, true);
    } else {
      detailsRow(row, true, false);
    }
  };

  let detailsRow = (row, show, append = false) => {
    const rowId = row.id();
    const parentRow = $(`#${rowId}`);

    if (!show) {
      parentRow.removeClass('details');
      storeCollapsed(rowId, true);
      return;
    }

    let template = require('./tmpl/partial/details-row.hbs');
    let tmplData = {
      ...row.data(),
      ...{
        $lang: $Lang,
        $config: $config,
        printMethod: getSelect2Value(rowId, 'print-method-select')
      }
    };

    const content = $(template(tmplData));

    if (append) content.appendTo($('td.child', row.child()));
    else row.child(content).show();

    parentRow.toggleClass('details', show);

    // Image popup
    $(`.magnific-image`).magnificPopup({ type: 'image' });
    $('.item-magnific-image', content).magnificPopup({ type: 'image' });

    content
      .off()
      .on('click', '.js-action-blankinfo-dialog', blankInfoDialog)
      .on('click', '.js-action-mpdpage-link', masterProductDataHandler)
      .on('click', '.js-action-artworkinfo-dialog', artworkInfoDialog)
      .on('click', '.js-action-bominfo-dialog', bomInfoDialog)
      .on('click', '.js-action-originalfile-download', originalFileDownload)
      .on('click', '.js-action-ksfdirectory-dialog', ksfDirectoryDialog)
      .on('click', '.js-action-trimslabelsfiles', (e) => {});

    // Select2 Dropdowns //.off().on('change', dropdownHandler)
    //$('.order-type-select, .print-method-select, .service-provider-select').select2('destroy');
    $('.order-type-select, .print-method-select, .service-provider-select').each(function () {
      if ($(this).data('select2')) {
        $(this).select2('destroy');
      }
    });

    $('.order-type-select, .print-method-select').select2().on('change', dropdownHandler);
    $('.service-provider-select').select2().on('change', serviceProviderDropdownHandler);

    storeCollapsed(rowId);
  };

  let storeCollapsed = (id, remove = false) => {
    if (!id) return;
    let collapsed = $storage.get('orderdetails-collapse') || [];
    // Remove Saved selected row
    collapsed = collapsed.filter((e) => e !== id);
    if (!remove) {
      // Save selected row
      collapsed.push(id);
    }
    $storage.set('orderdetails-collapse', collapsed);
  };

  let restoreCollapsed = () => {
    let collapsed = $storage.get('orderdetails-collapse');
    if (collapsed && collapsed.length) {
      setTimeout(() => {
        collapsed.forEach((id) => {
          $(`.details-control[data-id="${id}"]`).click();
        });
      }, 100);
    }
  };

  let productInfoDialog = (e) => {
    let id = $(e.target).data('id');
    let accountId = $(e.target).data('accountid');
    if (!id) return;
    ProductInfo.dialog(id, { accountId, pageUrl: 'listings', colorsDisabled: true });
  };

  let productStatusErrorDialog = (e) => {
    const id = $(e.target).data('id');
    const data = App.pageData('ordersGridData') || [];
    const item = data.find((o) => o.id === id);

    if (!item) {
      return;
    }

    orderProductionStatusErrorModal.init('orderProductionStatusErrorModal', {
      productionStatusMessage: item.productionStatusMessage
    });
  };

  let blankInfoDialog = (e) => {
    const blankId = $(e.target).data('blankid');
    if (blankId) {
      BlankInfo.dialog(blankId, false, true);
    }
  };

  let artworkInfoDialog = (e) => {
    e.stopPropagation();
    const artworkId = $(e.target).data('artworkid');
    const accountId = $(e.target).data('accountid');
    if (artworkId) {
      ArtworkInfo.dialog(artworkId, () => null, true, accountId);
    }
  };

  let bomInfoDialog = (e) => {
    const id = $(e.target).data('productid');
    const title = $(e.target).data('title');
    const createdDate = $(e.target).data('createddate');
    const standartId = $(e.target).data('standartid');
    const accountId = $(e.target).data('accountId');
    const modalConfig = {
      accountId,
      apiUrl: $config.apiURL,
      title,
      standartId,
      createdDate,
      id,
      requestId: id,
      urlPath: 'SKUCatalog/get-bom-files-by-product',
      requestPageType: 'MockupBomFolder',
      directoryName: 'BOM',
      isKSF: false
    };

    if (modalConfig.requestId) {
      MockupStatus.init('mockupStatusModal', modalConfig);
    }
  };

  let ksfDirectoryDialog = (e) => {
    let target = $(e.target).hasClass('js-action-ksfdirectory-dialog')
      ? $(e.target)
      : $(e.target).closest('.js-action-ksfdirectory-dialog');

    const id = target.data('lineitemid');
    const printpanel = target.data('printpanel');
    const printerid = target.data('printerid');

    if (!id || !printpanel) {
      return;
    }

    const ksfDirectory = $dataGrid
      .row(`#${id}`)
      .data()
      .dtgPrintInfoPerPanel.find((panel) => panel.printPanel == printpanel);

    const directoryItems = printerid
      ? ksfDirectory.ksfDirectoryItems.find((item) => item.printer.id === printerid)
      : ksfDirectory.ksfDirectoryItems;

    if (!directoryItems?.directoryFiles?.length) {
      return;
    }
    const title = printerid ? directoryItems?.printer?.columnTitle : null;

    KSFModal.init('ksf-files-modal', directoryItems.directoryFiles, 'body', title);
  };

  let originalFileDownload = (e) => {
    e.stopPropagation();
    const target = $(e.target).hasClass('js-action-originalfile-download')
      ? $(e.target)
      : $(e.target).closest('.js-action-originalfile-download');
    const assetId = target.data('assetid');
    const printmethod = target.data('printmethod') || target.closest('table').data('printmethod');
    const accountId = $(e.target).data('accountId');
    if (!assetId || !printmethod) return;
    UI.blockPage();
    Common.saveFile(`${$config.apiURL}orders/download/${printmethod}/${accountId}/${assetId}`);
  };

  let exportToExel = () => {
    let dataTableData = $.fn.dataTable.isDataTable(dataGridId) ? $(dataGridId).DataTable().data() : [];

    if (!dataTableData.length) {
      return;
    }
    let Store = Common.getQueryVal('Store', document.location.href) || selectedStore;
    let url = Store !== 'All' ? `/toexcel/${Store}/${User.accountID()}` : `/toexcel/all/${User.accountID()}`;
    let array = $.map(dataTableData, function (o) {
      return o.id;
    });
    let param = jQuery.param({ itemsId: array }, true);
    let urlGen = `${$config.apiURL}/orders/${url}?${param}`;
    window.open(urlGen, '_blank');
  };

  let masterProductDataHandler = (e) => {
    const target = $(e.target).hasClass('js-action-mpdpage-link')
      ? $(e.target)
      : $(e.target).closest('.js-action-mpdpage-link');

    let licensedProductid = target.data('licensedproductid');
    if (!licensedProductid) return;
    let accountId = $(e.target).data('accountid');
    $router.push(
      `/orders/${licensedProductid}/${accountId}/masterProductData${target.data('productiontab') ? '?tab=production' : ''}`
    );
  };

  let masterProductDataPage = (id, accountId, providerCode) => {
    MasterProductData.init(id, accountId, lastQuery, providerCode);
  };

  let accountChange = () => {
    // Store selected Accounts
    User.selectedAccounts.store('orders');

    if ($('body[current-action="orders"]').length) $dataGrid.draw(false);
    else $router.push('/orders');
  };

  let submitOrders = () => {
    const selected = App.pageData('selectedOrdersRows') || [];

    const submitOrders = selected.filter((order) => order.controlActive && !order.checkDisable);

    if (!submitOrders.length) return;

    // Set first facility from list
    const mappedSelectedItems = submitOrders.map((order) => {
      const lookupServiceProviders = order.lookupServiceProviders.map((lookupServiceProvider) => {
        const facilities = lookupServiceProvider.facilities;
        const facility = facilities.length ? {
          ...facilities[0],
          isSelected: lookupServiceProvider.id === order.serviceProviderId,
        } : null;

        return {
          ...lookupServiceProvider,
          isSelected: lookupServiceProvider.id === order.serviceProviderId,
          facilities: facility ? [facility] : []
        }
      });

      return {
        accountId: order.accountId,
        lineItemInStoreId: order.lineItemInStoreId,
        serviceProviderId: order.serviceProviderId,
        orderType: order.orderType,
        printMethod: order.printMethod,
        lookupServiceProviders
      }
    });

    doSubmit({
      accountId: submitOrders[0].accountId,
      items: mappedSelectedItems
    });
  };

  const doSubmit = (data) => {
    UI.block('#page');
    $.when(App.ajaxData('/orders/resolveLineItem', data, 'POST')).done((res) => {
      UI.unblock('#page');

      if (!res.isSuccess) {
        if (res?.errorInformation?.errorDataType === 'Specific' && res.errorData) {
          data.errorData = res.errorData;
          return submitErrorSpecific(data, () => doSubmit(data));
        }
      }

      submitSuccess();
    });
  };

  const doCancelDelete = (type) => {
    let selected = App.pageData('selectedOrdersRows') || [];
    if (!selected.length) {
      return;
    }

    let message;

    switch (type) {
      case 'cancel':
        message = $Lang.orders.AreYouSureCancel;
        break;
      case 'cancel-line-items':
        message = $Lang.orders.AreYouSureCancelLineItems;
        break;
      default:
        message = $Lang.orders.AreYouSureDelete;
    }

    const data = selected.map(order => order.lineItemInStoreId);

    bootbox.dialog({
      message,
      title: $Lang.orders.AreYouSure,
      className: 'modal-danger deletemessage-dialog-modal',
      buttons: {
        confirm: {
          label: $Lang.btn.yes,
          className: 'btn btn-danger bbw-border-radius',
          callback: () => {
            UI.block('#page');

            $.when(App.ajaxData(
              `orders/${type}`,
              data,
              'POST',
              'application/json',
              null,
              null,
              true
            )).done((res) => {
              UI.unblock('#page');

              if (!res.isSuccess) {
                if (res?.errorInformation?.errorDataType === 'Specific' && res.errorData) {
                  data.errorData = res.errorData;
                  return submitErrorSpecific(data, () => doSubmit(data));
                }

                if (res?.errorInformation) {
                  return;
                }
              }

              submitSuccess();
            });
          }
        },
        cancel: {
          label: $Lang.btn.cancel,
          className: 'btn btn-hover-dark bbw-border-radius'
        }
      }
    });
  }

  const submitErrorSpecific = (data, continueCallback) => {
    const template = require('./tmpl/dialog/submitOrderMessage.hbs');
    const buttons = data.errorData.canContinue
      ? {
          continue: {
            label: $lang.btn.Continue,
            className: 'btn btn-brand',
            callback: () => {
              continueCallback && continueCallback();
            }
          },
          cancel: {
            label: $lang.btn.cancel,
            className: 'btn btn-link'
          }
        }
      : {
          ok: {
            label: $lang.btn.gotIt,
            className: 'btn btn-brand'
          }
        };
    bootbox.dialog({
      size: 'xl',
      title: `<i class="fal fa-exclamation-triangle text-danger mr-2"></i> ${data.errorData.title}`,
      message: template({ errorData: data.errorData, $lang }),
      buttons: buttons
    });
  };

  const submitSuccess = () => {
    App.pageData('selectedOrdersRows', []);
    App.pageData('submitOrdersEnabled', false);
    $dataGrid.draw(false);
    UI.notify({
      text: $Lang.alert.SuccessfullySaved,
      icon: 'fal fa-check-circle',
      type: 'success'
    });
  };

  const selectHandler = (e) => {
    const target = $(e.target);
    const id = target.data().id;
    const checked = target.is(':checked');

    updateSelectedData(id, !checked);
  };

  const updateSelectedData = (id, remove = false) => {
    let selected = App.pageData('selectedOrdersRows') || [];
    const data = App.pageData('ordersGridData') || [];
    const item = data.find((o) => o.id === id);
    if (remove) {
      selected = selected.filter((item) => item.lineItemInStoreId !== id);
    } else {
      selected.push({
        accountId: $dataGrid.row(`#${id}`).data().accountId,
        lineItemInStoreId: id,
        serviceProviderId: getSelect2Value(id, 'service-provider-select'),
        orderType: getSelect2Value(id, 'order-type-select'),
        printMethod: getSelect2Value(id, 'print-method-select'),
        lookupServiceProviders: item && item.lookupServiceProviders ? item.lookupServiceProviders : [],
        controlActive: item.controlActive,
        checkDisable: item.checkDisable
      });
    }
    App.pageData('selectedOrdersRows', selected);

    App.pageData(
      'submitOrdersEnabled',
      selectedStore !== 'Archive' && selected.some((order) => order.controlActive && !order.checkDisable)
    );
  };

  const getSelect2Value = (id, classname) => {
    return $(`[data-lineiteminstoreid="${id}"].${classname}:visible`).val();
  };

  return {
    init,
    accountChange,
    submitErrorSpecific
  };
})();
